/* FANNUR v0.5 | photo module: cover crop, filters, frame as PRINTED line (no physical frame) */
(function () {
  'use strict';
  const PRESETS={
    original:[1,1,1,0,0],
    mono:[0,1.06,1.04,0,0],
    warm:[1,.98,1.07,13,0],
    soft:[1,1.03,.92,2,0],
    noir:[0,1.35,1.08,0,0]
  };
  function applyFilter(ctx, preset, amount){
    const p=PRESETS[preset]||PRESETS.original, t=Math.max(0,Math.min(1,amount/100));
    const sat=p[0]===0?(100-100*t):100;
    const contrast=(1+(p[1]-1)*t)*100, bright=(1+(p[2]-1)*t)*100;
    const sepia=Math.round(p[3]/100*100*t), gray=p[0]===0?100*t:0;
    ctx.filter=`grayscale(${gray}%) sepia(${sepia}%) saturate(${sat}%) contrast(${contrast}%) brightness(${bright}%)`;
  }
  function clippedPhoto(ctx,state,rect){
    ctx.fillStyle='#ebe8e2';ctx.fillRect(rect.x,rect.y,rect.w,rect.h);
    if(!state.image){
      ctx.fillStyle='#87877f';ctx.font='25px Arial';ctx.textAlign='center';ctx.textBaseline='middle';
      ctx.fillText(window.FANNUR_I18N?.t('uploadPhoto')||'Choose a photo',rect.x+rect.w/2,rect.y+rect.h/2);
      return;
    }
    ctx.save();ctx.beginPath();ctx.rect(rect.x,rect.y,rect.w,rect.h);ctx.clip();
    const img=state.image;
    const zoom=state.zoom/100;
    const cover=Math.max(rect.w/img.naturalWidth,rect.h/img.naturalHeight)*zoom;
    const w=img.naturalWidth*cover,h=img.naturalHeight*cover;
    const dx=(rect.w-w)/2+state.panX/100*rect.w*.5;
    const dy=(rect.h-h)/2+state.panY/100*rect.h*.5;
    applyFilter(ctx,state.filter,state.filterAmount);
    ctx.drawImage(img,rect.x+dx,rect.y+dy,w,h);
    ctx.restore();
    if(state.border!=='none'){
      ctx.save();ctx.strokeStyle=state.ink;ctx.lineWidth=state.border==='wide'?18:3;
      const inset=ctx.lineWidth/2+1;ctx.strokeRect(rect.x+inset,rect.y+inset,rect.w-2*inset,rect.h-2*inset);ctx.restore();
    }
  }
  function lines(ctx,text,width,maxLines){
    const words=String(text||'').split(/\s+/).filter(Boolean);const out=[];let line='';
    for(const w of words){const trial=line?`${line} ${w}`:w;
      if(line&&ctx.measureText(trial).width>width){out.push(line);line=w;}else line=trial;}
    if(line)out.push(line);
    return out.slice(0,maxLines);
  }
  function drawText(ctx,text,y,size,font,ink,width,maxLines=2){
    ctx.fillStyle=ink;ctx.textAlign='center';ctx.textBaseline='middle';
    const raw=String(text||'');let sz=size, ls=[];
    while(sz>=18){ctx.font=`${sz}px "${font}"`;ls=lines(ctx,raw,width,maxLines);
      if(ls.join(' ').length>=raw.trim().length)break;sz-=2;}
    ls.forEach((line,i)=>ctx.fillText(line,ctx.canvas.__logicalW/2,y+(i-(ls.length-1)/2)*sz*1.14,width));
  }
  function getRect(t,W,H){return t.layout==='photo-modern'?{x:W*.07,y:H*.075,w:W*.86,h:H*.70}:{x:W*.095,y:H*.09,w:W*.81,h:H*.64};}
  function draw(ctx,t,s,W,H){
    ctx.canvas.__logicalW=W;
    ctx.fillStyle=s.bg;ctx.fillRect(0,0,W,H);
    const r=getRect(t,W,H);clippedPhoto(ctx,s,r);
    const modern=t.layout==='photo-modern';
    drawText(ctx,s.values.title,H*(modern?.83:.815),W*(modern?.059:.077),s.fontFamilies?.heading||'Georgia',s.ink,W*.83,2);
    drawText(ctx,s.values.subtitle,H*(modern?.89:.91),W*.029,s.fontFamilies?.detail||'Georgia',s.ink,W*.79,2);
  }
  window.FANNUR_MODULES_V05=window.FANNUR_MODULES_V05||{};
  window.FANNUR_MODULES_V05['photo-upload']={draw,getRect};
})();
